import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-metrics',
    templateUrl: './metrics.component.html',
    styleUrls: ['./metrics.component.scss'],
    standalone: false
})
export class MetricsComponent implements OnInit {
  @Input() metrics: string = '';
  @Input() classes: string[] = [];

  constructor() {}

  ngOnInit(): void {}
}
